import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=0277b500&scoped=true&"
import script from "./PersonDetails.vue?vue&type=script&lang=js&"
export * from "./PersonDetails.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=0277b500&prod&scoped=true&lang=css&"
import style1 from "./PersonDetails.vue?vue&type=style&index=1&id=0277b500&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0277b500",
  null
  
)

export default component.exports